export default {
    "stats.title": "My Statistics",
    "stats.nav.dashboard": "Dashboard",
    "stats.last_update": "Updated in real-time",
    "stats.global.quiz": "Quiz Completion",
    "stats.global.accuracy": "Global Accuracy",
    "stats.global.review": "Questions to Review",
    "stats.global.streak": "Streak",
    "stats.global.streak_unit": "d",

    "stats.badges.title": "Badges & Achievements",
    "stats.badges.count": "{{count}} Badge",
    "stats.badges.count_plural": "{{count}} Badges",
    "stats.badges.congrats": "Congratulations on this achievement!",
    "stats.badges.empty_title": "No achievements yet",
    "stats.badges.empty_desc": "Keep learning to unlock exclusive badges.",

    "stats.charts.progress_title": "Progress by Theme",
    "stats.charts.accuracy_title": "Success Rate",
    "stats.charts.legend_progress": "Progress",
    "stats.charts.legend_accuracy": "Accuracy",

    "stats.table.title": "Details by Category",
    "stats.table.col_quiz": "Theme",
    "stats.table.col_flashcards": "Flashcards",
    "stats.table.col_accuracy": "Accuracy",
    "stats.table.col_challenges": "Challenges",
    "stats.table.col_action": "Action",
    "stats.table.quiz_count": "{{completed}} / {{total}} quizzes",
    "stats.table.flashcards_desc": "Cards memorized",
    "stats.table.errors_count": "{{count}} error(s)",
    "stats.table.perfect": "100% Mastered",
    "stats.table.review_btn": "Review"
};
